//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin'

export default BaseCmsBlock.extend({
  name: "SubpagesBlock",

  data: function () {
    return {}
  },

  computed: {
    links: function () {
      return (this.extras?.subpages || [])
        .map((_page) => {
          return {
            ..._page,
            href: String(`/${_page.href}`).replace('//', '/')
          }
        });
    }
  }

})
